<template>
  <v-container>
    <v-card>
      <v-card-title>
        <h3>{{ name }}'s profile</h3>
      </v-card-title>

      <user-profile :userId="id"></user-profile>
    </v-card>

    <v-card>
      <v-card-title>
        <div>
          <h3 class="headline">Manage {{ name }}'s trips</h3>
        </div>
      </v-card-title>

      <v-btn @click="addingItinerary = true" v-if="!addingItinerary">
        <v-icon dark left>pe-7s-plus</v-icon>Add travefy trip
      </v-btn>

      <new-itinerary v-if="addingItinerary" :userId="id" @addItinerary="addItinerary"></new-itinerary>

      <v-data-table
        :headers="[
          { text: 'Start date', value: 'startDate' },
          { text: 'End date', value: 'endDate' },
          { text: 'Name', value: 'name' },
          { text: 'Destination', value: 'destination' },
          { text: 'Actions', sortable: false }
        ]"
        hide-actions
        sort-icon="arrow_carrot-up"
        :items="itineraries"
      >
        <template v-slot:items="props">
          <td>{{ props.item.data.startDate }}</td>
          <td>{{ props.item.data.endDate }}</td>
          <td>{{ props.item.data.name }}</td>
          <td>{{ props.item.data.destination }}</td>
          <td>
            <v-btn
              flat
              icon
              :to="{ name: 'backend-travefytrip', params: { uid: id, id: props.item.id }}"
            >
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon flat @click="deleteItinerary(props.item.id)">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { Database } from '@/library/firebase'

import NewItinerary from '@/components/backend/NewItinerary'
import UserProfile from '@/components/backend/UserProfile'

export default {
  components: {
    NewItinerary,
    UserProfile
  },
  data () {
    return {
      id: this.$route.params.id,
      name: '',
      email: '',
      itineraries: [],
      addingItinerary: false
    }
  },
  methods: {
    getUser () {
      Database.ref('users').child(this.id).once('value').then(data => {
        this.email = data.val().email
        this.name = data.val().name
      })
    },
    getTrips () {
      Database.ref('travefyTrips').child(this.id).once('value').then(data => {
        data.forEach(trip => {
          this.itineraries.push({
            id: trip.key,
            data: trip.val()
          })
        })
      })
    },
    addItinerary (trip) {
      this.itineraries.push(trip)
      this.addingItinerary = false
    },
    deleteItinerary (id) {
      if (confirm('Do you really want to delete this trip?')) {
        Database.ref('travefyTrips').child(this.id).child(id).remove()

        let index = this.itineraries.findIndex(t => t.id === id)
        this.itineraries.splice(index, 1)
      }
    }
  },
  mounted () {
    this.getUser()
    this.getTrips()
  }
}
</script>

<style>
</style>
